<template>
  <b-modal
      id="modal-table"
      shadow
      bg-variant="white"
      backdrop
      hide-footer
      centered
    >
    <div class="justify-content-between align-items-center content-sidebar px-1">
      <b-form>
        <b-row> 
          <b-col
            cols="12"
            class="title-modal"
          >
            <div class="container-title-text-modal d-flex align-items-center">
              <h5>
                Detalhes CDO {{TitleVar}}
              </h5> 
            </div>
          </b-col>
        
          <div class="table-responsive">
            <b-table
              class="table-cbo"
              :sticky-header="stickyHeader"
              :no-border-collapse="noCollapse"
              :items="rows"
              :fields="fields"
              :striped="striped"
              :sort-by="sortBy"
              :sort-desc="sortDesc"   
            >
                <!-- Slot: Table Column -->
              <template #head()="scope">
                <div class="text-nowrap">
                  {{ $t(scope.label) }}
                </div>
              </template>
              
              <!-- Slot: Table Row -->
              <template
                v-for="slot in Object.keys($scopedSlots)"
                v-slot:[slot]="props"
              >
                <slot v-bind="props" :name="slot" />
              </template>
            </b-table>
            <div class="not-found" v-if="rows.length == 0">
                <span><SearchIcon /><h3>Nenhum resultado encontrado!</h3></span>
            </div>
          </div>
        </b-row>
      </b-form>
    </div> 
  </b-modal>   
</template>
    
<script>
import {
  BForm, 
  BTable, 
  BRow, 
  BCol,
  BModal,
} from 'bootstrap-vue';

export default {
  components: {
    BRow,
    BCol,
    BTable,
    BForm,
    BModal
  },
  props: {
    TitleVar: {
      type: String,
      default: ''
    },
    rows: {
        type: Array,
        default: null,
    },
    fields: {
        type: Array,
        default: null,
    },
    noCollapse: {
        type: Boolean,
        default: true,
    },
    stickyHeader: {
        type: String,
        default: true,
    },
    striped: {
        type: Boolean,
        default: false,
    },
    sortDesc: {
        type: Boolean,
        default: false,
    },
    sortBy: {
        type: String,
        default: "",
    },
  },
  data() {
    return{
    }
  },
}
</script>

<style lang="scss">
@media (min-width:768px) {
  #modal-table{
    padding: 0 !important;
    .modal-content,
    .modal-dialog{
      width: 746px !important;
    }
  }
}
#modal-table{
  .table-responsive{
    margin-top: -18px !important;
  }
}
#modal-table{
  padding: 20px 0 0 8px;
  .modal-dialog{
    width: 95%;
    max-width: none;
  }
  .modal-content{
    width: 100%;
    right: 0 !important;
  }
  .modal-header{
    height: 66px;
    background: #ECEFF1;
  }
  .modal-body{
    padding: 6px 2px 0.8rem !important;
    .title-modal{
      h5{
        height: 20px;
        font-family: 'Roboto';
        font-style: normal;
        font-weight: 600;
        font-size: 18px;
        line-height: 26px;
        color: #4C4541;
        margin-bottom: 0;
      }
      .container-title-text-modal{
        margin-top: -72px;
        height: 66px;
        width: 100%;
      }
    }
    .col-form-label{
      color: #4C4541;
      font-family: 'Roboto';
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
    }
  }
}
</style>